import { Person, LocalMall, Store, Stars, Redeem } from '@material-ui/icons';
import { ListItem } from 'design-system';

export const SearchInstructions = () => {
  return (
    <>
      <ListItem iconTooltipText="Customer" icon={<Person />} text="Customer Email or Cognito ID" />
      <ListItem iconTooltipText="Order" icon={<LocalMall />} text="RBI Order ID" />
      <ListItem iconTooltipText="Gift Card" icon={<Redeem />} text="Gift Card Number" />
      <ListItem
        iconTooltipText="Store"
        icon={<Store />}
        text="Store Number, Sanity ID or Address"
      />
      <ListItem
        iconTooltipText="Loyalty"
        icon={<Stars />}
        text="Loyalty ID Or Phone Number (10-digit)"
      />
    </>
  );
};
